
export class PageEnum implements IPageEnum {
  name:string;
  title:string;
  is(page:PageEnum) {
    return this.name===page.name;
  }
  constructor(name:string, title?:string) {
    this.name = name;
    this.title = title ? title : this.name;
  }
}

interface IPageEnum {
  name:string;
  title:string;
}

export const PageEnums = {
  loading: new PageEnum('loading'),
  dashboard: new PageEnum('dashboard'),
  feedLandingPage: new PageEnum('Feed', '${solution} Feed'),
  register:new PageEnum('register'),
  mainstageQuestions:new PageEnum('mainstage-questions', 'Mainstage Q&A'),
  custom:new PageEnum('custom'),
  booth:new PageEnum('booth', '${bundle}'),
  mainstage:new PageEnum('mainstage', 'Main Stage'),
  biometrics:new PageEnum('biometrics'),
  myCoaching:new PageEnum('my-coaching', 'My Coaching'),
  prizes: new PageEnum('rewards', 'Prizes'),
  headspace: new PageEnum('headspace', 'Headspace'),
  calm: new PageEnum('calm', 'Calm'),
  foodswitch: new PageEnum('foodswitch', 'FoodSwitch'),
  myWellness: new PageEnum('my-wellness', 'Goals'),
  counseling: new PageEnum('counseling', 'Nutrition Counseling'),
  library: new PageEnum('Library'),
  vitabot: new PageEnum('vitabot', 'Vitabot'),
  shopwell: new PageEnum('shopwell', 'ShopWell'),
  quitnow: new PageEnum('QuitNow', 'Quit Now'),
  login: new PageEnum('login'),
  solutionDetail: new PageEnum('solutionDetail', '${solution}'),
  solutionRegister: new PageEnum('solutionRegister', 'Register for ${solution}'),
  profile: new PageEnum('profile', "Your Profile"),
  badgeHistory: new PageEnum('badge-history', "Badge History"),
  hr: new PageEnum('hr-app', 'Client Admin Dashboard'),
}
